import { mutator } from 'satcheljs';
import {
    initializeScenario,
    updateShouldAutoScroll,
    updateTopOfListIndex,
} from '../actions/internalActions';
import {
    updateSelectedCalendarEvent,
    updateSearchText,
    updateShouldShowTasks,
    updateIncludeDeclinedEvents,
} from '../actions/publicActions';
import { getScenario } from '../selectors/agendaStoreSelectors';
import { getAgendaStore } from '../store/agendaStore';

mutator(updateSelectedCalendarEvent, actionMessage => {
    const { selectedCalendarEventId, scenarioId } = actionMessage;
    getScenario(scenarioId).selectedCalendarEventId = selectedCalendarEventId;
});

mutator(updateTopOfListIndex, actionMessage => {
    const { scenarioId, topOfListIndex } = actionMessage;
    getScenario(scenarioId).topOfListIndex = topOfListIndex;
});

mutator(updateShouldAutoScroll, actionMessage => {
    const { shouldAutoScroll, scenarioId } = actionMessage;
    getScenario(scenarioId).shouldAutoScroll = shouldAutoScroll;
});

mutator(updateSearchText, actionMessage => {
    const { searchText, scenarioId } = actionMessage;
    getScenario(scenarioId).searchText = searchText;
});

mutator(updateShouldShowTasks, actionMessage => {
    const { shouldShowTasks, scenarioId } = actionMessage;
    getScenario(scenarioId).shouldShowTasks = shouldShowTasks;
});

mutator(updateIncludeDeclinedEvents, actionMessage => {
    const { shouldShowDeclinedEvents, scenarioId } = actionMessage;
    getScenario(scenarioId).shouldShowDeclinedEvents = shouldShowDeclinedEvents;
});

mutator(initializeScenario, actionMessage => {
    const {
        scenarioId,
        viewConfig,
        todoActionSource,
        shouldShowDeclinedEvents,
        shouldShowTasks,
    } = actionMessage;
    if (!getAgendaStore().scenarios.has(scenarioId)) {
        getAgendaStore().scenarios.set(scenarioId, {
            selectedCalendarEventId: null,
            shouldAutoScroll: true,
            topOfListIndex: 0,
            viewConfig: viewConfig,
            searchText: null,
            shouldShowTasks: shouldShowTasks,
            shouldShowDeclinedEvents: shouldShowDeclinedEvents,
            todoView: {
                todoActionSource: todoActionSource,
                currentEditingTodoId: null,
                contextMenuViewState: null,
                quickAddViewState: {
                    isShown: true,
                    subject: '',
                    isFocused: false,
                    linkedEmailEntity: undefined,
                },
            },
        });
    }
});
